export default __webpack_public_path__ + "static/media/eclipse2.587071ea.svg";